import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { CurrencyNote } from './CurrencyNote';
import { bonuses, offerIncludes } from '../data/content';
import { CtaButton } from './CtaButton';
import { ProductCollage } from './ProductCollage';
import { BonusFan } from './BonusFan';
import { PrintCutShare } from './PrintCutShare';
import { SunRays } from './decor/SunRays';
export function FinalOffer() {
  return <section id="offer" aria-labelledby="offer-title" className="relative overflow-hidden bg-cream-deep" data-id="element-101" data-mp="1qdjlsfn7om7g">
      <SunRays className="pointer-events-none absolute -right-40 -top-40 w-[560px] text-gold/20" data-id="element-102" data-mp="1lep2zdp8uxnc" />
      <div className="relative mx-auto max-w-content px-5 py-20 sm:px-8 lg:py-28" data-id="element-103" data-mp="20335fnir0k3d">
        <h2 id="offer-title" className="mx-auto max-w-3xl text-balance text-center font-display text-[40px] leading-[1.04] text-navy sm:text-[58px]" data-id="element-104" data-mp="1v51p3acpiyvl">
          Obtenez dès aujourd’hui le Pack Complet d’Évangélisation
        </h2>

        <div className="mt-14 space-y-6" data-id="element-105" data-mp="247t0xb9hvwnr">
          <ProductCollage data-id="element-106" data-mp="1pp1tlo980it" />
          <BonusFan data-id="element-107" data-mp="1qic2wmf985p" />
        </div>

        <div className="mx-auto mt-12 grid max-w-5xl overflow-hidden rounded-3xl bg-white shadow-sheet ring-2 ring-coral/25 md:grid-cols-[1.2fr_1fr]" data-id="element-108" data-mp="1rjmqzzizsmw">
          <div className="p-7 sm:p-9" data-id="element-109" data-mp="bnd735jhkqf8">
            <p className="text-xs font-extrabold uppercase tracking-[0.14em] text-coral-deep" data-id="element-110" data-mp="bmbli74uglj9">Votre pack numérique comprend :</p>
            <ul className="mt-5 space-y-3" data-id="element-111" data-mp="kob0ktwatfjk">
              {offerIncludes.map(item => <li key={item} className="flex items-start gap-3 font-bold text-navy" data-id="element-112" data-mp="kmgpe7atx1so">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-leaf-deep" strokeWidth={3} aria-hidden="true" data-id="element-113" data-mp="plb7t84vwoc9" />
                  {item}
                </li>)}
            </ul>
            <p className="mt-8 text-xs font-extrabold uppercase tracking-[0.14em] text-gold-deep" data-id="element-114" data-mp="zfa77zdkpu0i">+ 5 bonus :</p>
            <ul className="mt-4 space-y-3" data-id="element-115" data-mp="14ah6muzt8cjm">
              {bonuses.map(b => <li key={b.number} className="flex items-start gap-3 font-bold text-navy" data-id="element-116" data-mp="18e5hbmjqno93">
                  <GiftIcon className="mt-0.5 h-5 w-5 shrink-0 text-coral" aria-hidden="true" data-id="element-117" data-mp="35erqs8gkyg36" />
                  {b.name}
                </li>)}
            </ul>
          </div>

          <div className="flex min-w-0 flex-col items-center justify-center bg-cream px-5 py-8 text-center sm:p-9" data-id="element-118" data-mp="3e8eh3j20qr4z">
            <p className="text-sm font-extrabold uppercase tracking-[0.12em] text-ink-mute" data-id="element-119" data-mp="39e0i76o5e1vk">
              Valeur totale <span className="line-through decoration-coral decoration-2" data-id="element-120" data-mp="3o6ubbuwcegip">$97</span>
            </p>
            <p className="mt-2 text-sm font-extrabold uppercase tracking-[0.14em] text-navy" data-id="element-121" data-mp="3j8amnmqd6qmn">Aujourd’hui seulement</p>
            <p className="font-display text-[80px] leading-[0.95] text-coral sm:text-[96px]" aria-label="$24.90" data-id="element-122" data-mp="3t4dnmp9hcj80">
              $24<span className="align-top text-[40px] leading-none sm:text-[48px]" data-id="element-123" data-mp="22qwmpa6bv3v4">.90</span>
            </p>
            <p className="mt-3 max-w-[18rem] text-balance text-sm font-semibold leading-relaxed text-ink-soft" data-id="element-124" data-mp="1yqusfm2x9cpv">
              Paiement unique · Sans abonnement · Accès numérique immédiat
              <span className="block" data-id="element-125" data-mp="1so9fg1n0uh1y">Mises à jour gratuites à vie.</span>
            </p>
            <CurrencyNote className="mt-6 border-t border-cream-line pt-5" data-id="element-126" data-mp="1ewl2xx8v1qkg" />
            <CtaButton checkout block className="mt-4" data-id="element-127" data-mp="1euig1m308djy">
              Obtenir le Pack Complet d’Évangélisation maintenant
            </CtaButton>
            <p className="mt-5 text-xs font-extrabold uppercase tracking-[0.14em] text-navy" data-id="element-128" data-mp="14x40rpsthut8">200+ versets bibliques • 20+ modèles</p>
            <div className="mt-3" data-id="element-129" data-mp="19yjo5oigwdes">
              <PrintCutShare data-id="element-130" data-mp="vxqoyqh80u5c" />
            </div>
            <p className="mt-3 font-display text-xl italic text-leaf-deep" data-id="element-131" data-mp="vz1sqqao21wg">Commencez dès aujourd’hui à semer l’Évangile.</p>
          </div>
        </div>
      </div>
    </section>;
}